// src/redux/workflows/notifications/slice.ts
import { createSlice } from '@reduxjs/toolkit';
import { NotificationsState } from './types';
import { fetchNotifications } from './thunk';

const initialState: NotificationsState = {
  data: [],
  count: 0,
  next: null,
  previous: null,
  loading: false,
  error: null,
};

const notificationsSlice = createSlice({
  name: 'workflows/notifications',
  initialState,
  reducers: {
    resetNotificationsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.count = payload.count;
        state.next = payload.next;
        state.previous = payload.previous;
        state.data = payload.results;
      })
      .addCase(fetchNotifications.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload ?? 'Failed to load notifications';
      });
  },
});

export const { resetNotificationsState } = notificationsSlice.actions;
export default notificationsSlice.reducer;
